import React, { useState, useEffect } from "react";
import StandAloneInpt from "../../../../components/stand-alone-input";
//import loader from "../../../../assets/images/tail-spin.svg";
import "./AddWage.scss";
import { isSameDay, isAfter } from "date-fns";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ReportDateRange from "../../../../components/reportDateRange";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "transperent" : "transperent",
        color: state.isSelected ? "black" : "black",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
    }),
    control: (provided, state) => ({
        ...provided,
        borderRadius: "5px",
    }),
    menu: (provided, state) => ({
        ...provided,
        borderRadius: "0px",
        marginTop: "6px",
    }),

    multiValueRemove: (provided, state) => ({
        display: "none",
    }),
};

export const AddWageAll = (props) => {

    const { editData } = props;
    const [startDate, setStartDate] = useState(editData?.startDate || new Date());
    const [endDate, setEndDate] = useState(editData?.endDate || new Date());
    const [minWage, SetMinWageValue] = useState(editData?.minWage || "");
    const [adding, updateAdding] = useState(false);
    const [error, ErrorMessage] = useState("");
    const [checkOverlapDate, updateOverlapDate] = useState(true);
    const [countyList, setCountyList] = useState(props.counties.map(el => ({ value: el._id, label: `${el.name}` })) || []);
    const [county, updateCounty] = useState(countyList.filter(res => res.label === props.isSelected));
    const [isEmptyEndDate, setIsEmptyEndDate] = useState(true);
    const [isEmptyStartDate, setIsEmptyStartDate] = useState(true);

    const save = async () => {
        if (isEmptyStartDate) {
            ErrorMessage('Start date is required')
            return;
        }
        if (!isEmptyEndDate) {
            let checkEndDate = endDate && Date.parse(startDate) < Date.parse(endDate);
            if (!checkEndDate) {
                ErrorMessage('End date cannot be earlier than Start date')
                return;
            }
        }
        if (props.wageList.length) {
            let lastWage = props.wageList[props.wageList.length - 1]
            if (lastWage.endDate) {
                //let modiEndDate = format(new Date(lastWage.endDate), "MM/dd/yyyy")
                let result = isAfter(new Date(startDate), new Date(lastWage.endDate))
                if (!result) {
                    ErrorMessage(`Start date must be later than ${lastWage.endDate}`)
                    return;
                }
            }
            //let modiStartDate = format(new Date(lastWage.startDate), "MM/dd/yyyy")
            var result = isAfter(new Date(lastWage.startDate), new Date(startDate))
            if (result) {
                ErrorMessage(`Please add the start date after ${lastWage.startDate}`)
                return;
            }

        }

        const dateStart = props.wageList.findIndex(res => isSameDay(new Date(res.startDate), new Date(startDate)));
        const dateEnd = props.wageList.findIndex(res => isSameDay(new Date(res.endDate), new Date(endDate)));

        if (dateStart > -1 || dateEnd > -1) {
            ErrorMessage('Date is invalid')
            return;
        }
        await overlapDate(startDate);
        let addPayload = {
            county: county[0].value,
            startDate: startDate,
            endDate: isEmptyEndDate ? "" : endDate,
            minWage: minWage,
        }
        await props.action.AddWageAction(addPayload);
        updateAdding(true);
        props.close(props.action.WAGE);

    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        // Add overflow class  in  body tag
        document.body.classList.add('overflow-hidden');

        if (!checkOverlapDate) {
            updateOverlapDate(true);
            if (props.wageList.length) {
                updateAdding(false);
            };
        };
    }, []);


    const overlapDate = async (sDate) => {
        if (props.wageList.length) {
            let lastWage = props.wageList[props.wageList.length - 1]
            if (!lastWage.endDate) {
                let endDate = new Date(sDate);
                let startDate = new Date(lastWage.startDate);
                let updatePayload = {
                    id: lastWage._id,
                    startDate: startDate,
                    endDate: endDate,
                    minWage: lastWage.minWage,
                }
                await props.action.UpdateWageAction(updatePayload);
            };
        };
    };

    const update = async (id) => {
        if (!isEmptyEndDate) {
            let checkEndDate = endDate && Date.parse(startDate) < Date.parse(endDate);
            if (!checkEndDate) {
                ErrorMessage(`Please add the end date after ${startDate}`)
                return;
            }
        }

        let dataList = props.wageList.findIndex(f => f._id === editData._id)
        if (props.wageList.length === dataList + 1) {
            let updatePayload = {
                id: editData._id,
                startDate: startDate,
                endDate: isEmptyEndDate ? '' : endDate,
                minWage: minWage,
            }
            await props.action.UpdateWageAction(updatePayload)
            updateAdding(true);
            props.close(props.action.WAGE);
        } else {
            let findIndex = props.wageList[dataList + 1]
            var result = isAfter(new Date(findIndex.startDate), new Date(endDate))
            if (result) {
                let updatePayload = {
                    id: editData._id,
                    startDate: startDate,
                    endDate: isEmptyEndDate ? '' : endDate,
                    minWage: minWage,
                }
                await props.action.UpdateWageAction(updatePayload)
                updateAdding(true);
                props.close(props.action.WAGE);
            } else {
                ErrorMessage(`Please add the end date before ${findIndex.startDate}`)
                return;
            }
        }



    };

    const handleStartApply = (date) => {
        //picker.element.val(picker.startDate.format("MM/DD/YYYY"));
        //let startDate = picker.startDate.format("MM/DD/YYYY");
        setStartDate(date)
        setIsEmptyStartDate(false)
    };

    const handleEndApply = (date) => {
        //picker.element.val(picker.startDate.format("MM/DD/YYYY"));
        //let endDate = picker.startDate.format("MM/DD/YYYY");
        setEndDate(date)
        setIsEmptyEndDate(false)
    };
    return (
        <div>
            <div className="add_rate_popup cntnt_wrpr">
                <div>
                    <Select
                        isDisabled={props.counties || props.counties.length}
                        placeholder="Location ID"
                        options={countyList}
                        value={county}
                        onChange={updateCounty}
                        hideSelectedOptions={false}
                        styles={customStyles}
                    />
                </div>
                <div className="date_column date-range">
                    <label className="label">Start Date</label>
                    <ReportDateRange
                        mode="single"
                        monthsShown={1}
                        startDate={startDate}
                        handleDateRange={handleStartApply}
                        style={{
                            input: {
                                width: '100%',
                            },
                        }}
                    />
                    {/* <DatePicker
                        selected={startDate}
                        onChange={handleStartApply}
                        todayButton="Today"
                    >
                    </DatePicker> */}
                    {error && <p className="error">{error}</p>}
                </div>

                <div className="date_column date-range">
                    <label className="label">End Date</label>
                    <ReportDateRange
                        mode="single"
                        monthsShown={1}
                        startDate={endDate}
                        handleDateRange={handleEndApply}
                        style={{
                            input: {
                                width: '100%',
                            },
                        }}
                    />
                    {/* <DatePicker
                        onChange={handleEndApply}
                        selected={endDate}
                        todayButton="Today"
                    >
                    </DatePicker> */}
                </div>

                <div className="date_column date-range">
                    <label className="label">Min Wage</label>
                    <StandAloneInpt
                        value={minWage}
                        id={`wageValue`}
                        change={SetMinWageValue}
                        field={"wageValue"} />
                </div>

                <div className="wage-footer">
                    <button
                        className="wage-btn wage-btn-cancel"
                        onClick={() => props.close()}
                    >
                        Cancel
                    </button>
                    <button
                        className="wage-btn wage-btn-primary"
                        disabled={!minWage || !startDate}
                        onClick={Object.keys(editData).length ? update : save}
                    >
                        {!adding ? Object.keys(editData).length ? 'Update' : 'Save' : ''}
                    </button>
                </div>
            </div>
        </div>
    );
};
